import { inventoryStatusQtyDetails } from "../Data/testData";

const ExpandableContentLayout = ({ row }: { row: any }) => {

    return (
        <>
            <div className="bg-transparent p-2">
                <table className="detailtable table count-details-nested-list mb-0">
                    <thead>
                        <tr className="custom-header-blue">
                            <th></th>
                            <th>Inventory Status</th>
                            <th className="ps-3">System Qty</th>
                        </tr>
                    </thead>
                    <tbody>
                        {inventoryStatusQtyDetails.map((detail, detailIndex) => (
                            <tr className="" key={detailIndex}>
                                <td className="bg-transparent"></td>
                                <td className="bg-transparent">{detail.inventory_status}</td>
                                <td className="bg-transparent ps-3">{detail.system_qty}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default ExpandableContentLayout;
